import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteBoardBoxSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_6144_65128" fill="white">
          <rect width="29.9963" height="14.2144" rx="1.09375" />
        </mask>
        <rect
          width="29.9963"
          height="14.2144"
          rx="1.09375"
          stroke={fill}
          strokeWidth="4"
          mask="url(#path-1-inside-1_6144_65128)"
        />
        <mask id="path-2-inside-2_6144_65128" fill="white">
          <rect y="15.7861" width="18.4592" height="14.2144" rx="1.09375" />
        </mask>
        <rect
          y="15.7861"
          width="18.4592"
          height="14.2144"
          rx="1.09375"
          stroke={fill}
          strokeWidth="4"
          mask="url(#path-2-inside-2_6144_65128)"
        />
        <mask id="path-3-inside-3_6144_65128" fill="white">
          <rect x="19.6172" y="15.7861" width="10.3833" height="14.2144" rx="1.09375" />
        </mask>
        <rect
          x="19.6172"
          y="15.7861"
          width="10.3833"
          height="14.2144"
          rx="1.09375"
          stroke={fill}
          strokeWidth="4"
          mask="url(#path-3-inside-3_6144_65128)"
        />
      </svg>
    </span>
  );
};

export default WhiteBoardBoxSVG;
